'use strict'

const _ = require('lodash')

class BaccaratRoadmap {

  constructor() {
    this.columns = 20
    this.rows = 6
    this.scroll = true
    this.gameResults
  }

  beadRoad(statistic, columns = this.columns, rows = this.rows, scroll = this.scroll) {
    const columnSize = rows
    const gameResults = _.values(statistic)
    let maximumColumnReached = 0
    let returnList

    returnList = _.range(0, gameResults.length)
      .map((index) =>
        _.assign({}, {
          column: this.columnForGameNumber(index, columnSize),
          row: this.rowForGameNumber(index, columnSize),
          marker: this.getMarker(gameResults[index]),
          score: gameResults[index].score || 0
        }))


    if (!_.isEmpty(returnList)) {
      maximumColumnReached = _.findLast(returnList).column

      if (scroll) {
        returnList = this.scrollBlock(returnList,
          maximumColumnReached, columns)
      }
    }

    return returnList
  }

  generateRoadmap(statistic, columns = this.columns, rows = this.rows, scroll = this.scroll) {

    const baseBigRoad = this.baseBigRoad(statistic, columns, rows)
    const beadRoad = this.beadRoad(statistic, columns, rows, scroll)
    const bigRoad = this.bigRoad(statistic, columns, rows, scroll)
    let bigEyeRoad = this.bigEyeRoad(baseBigRoad, columns, rows, scroll)
    let smallRoad = this.smallRoad(baseBigRoad, columns, rows, scroll)
    let cockroachRoad = this.cockroachRoad(baseBigRoad, columns, rows, scroll)

    let nextRoundHasPlayer = this.askNextRound(this.askPlayer(statistic))
    let nextRoundHasBanker = this.askNextRound(this.askBanker(statistic))

    const data = {
      beadRoad: beadRoad,
      bigRoad: bigRoad,
      bigEyeRoad: bigEyeRoad,
      smallRoad: smallRoad,
      cockroachRoad: cockroachRoad,
      // nextRoundHasPlayer: nextRoundHasPlayer || {},
      // nextRoundHasBanker: nextRoundHasBanker || {},
      nextRoundHas: {
        player: nextRoundHasPlayer || {},
        banker: nextRoundHasBanker || {}
      }
    }
    return data
  }

  askNextRound(statistic) {
    const baseBigRoad = this.baseBigRoad(statistic)

    let bigEyeRoad = this.bigEyeRoad(baseBigRoad)
    let smallRoad = this.smallRoad(baseBigRoad)
    let cockroachRoad = this.cockroachRoad(baseBigRoad)

    let data = {}

    if (!_.isEmpty(bigEyeRoad)) {
      const nextRound = _.findLast(bigEyeRoad)
      data = _.assign(data, { bigEyeRoad: nextRound.marker })
    }

    if (!_.isEmpty(smallRoad)) {
      const nextRound = _.findLast(smallRoad)
      data = _.assign(data, { smallRoad: nextRound.marker })
    }

    if (!_.isEmpty(cockroachRoad)) {
      const nextRound = _.findLast(cockroachRoad)
      data = _.assign(data, { cockroachRoad: nextRound.marker })
    }

    return data
  }

  baseBigRoad(statistic, columns = this.columns, rows = this.rows) {
    return this.roadmap(statistic, columns, rows, false)
  }

  bigRoad(statistic, columns = this.columns, rows = this.rows, scroll = this.scroll) {
    return this.roadmap(statistic, columns, rows, scroll)
  }

  bigEyeRoad(baseBigRoad, columns = this.columns, rows = this.rows, scroll = this.scroll) {
    return this.otherRoad('BigEyeRoad', baseBigRoad, columns, rows, scroll)
  }

  smallRoad(baseBigRoad, columns = this.columns, rows = this.rows, scroll = this.scroll) {
    return this.otherRoad('SmallRoad', baseBigRoad, columns, rows, scroll)
  }

  cockroachRoad(baseBigRoad, columns = this.columns, rows = this.rows, scroll = this.scroll) {
    return this.otherRoad('CockroachRoad', baseBigRoad, columns, rows, scroll)
  }

  askPlayer(statistic) {
    const newData = {
      winner: 'PLAYER'
    }
    return _.concat(statistic, newData)
  }

  askBanker(statistic) {
    const newData = {
      winner: 'BANKER'
    }
    return _.concat(statistic, newData)
  }

  asking(type) {
    return {
      winner: type.toUpperCase()
    }
  }

  roadmap(statistic, columns = this.columns, rows = this.rows, scroll = this.scroll) {
    let tieStack = []
    let placementMap = {}
    let logicalColumnNumber = 0
    let lastItem
    let returnList = []
    let maximumColumnReached = 0
    let beforeLastItem = null
    const gameResults = _.values(statistic)

    gameResults.forEach((gameResult) => {

      if (gameResult.winner === 'TIE') {

        tieStack.push(gameResult.winner)
      } else {

        if (lastItem) {

          let lastItemInResults = _.last(returnList)
          if (lastItemInResults) {
            beforeLastItem = lastItemInResults.result
          }

          if (lastItem.winner === 'TIE') {
            if (lastItemInResults) {

              lastItemInResults.ties = _.cloneDeep(tieStack)
              tieStack = []
            }

            if (beforeLastItem !== gameResult.winner && beforeLastItem !== null) {
              tieStack = []
              logicalColumnNumber++
            }
          } else if (lastItem.winner !== gameResult.winner) {
            tieStack = []
            logicalColumnNumber++
          }
        }

        let probeColumn = logicalColumnNumber
        let probeRow = 0
        let done = false

        while (!done) {
          let keySearch = `${probeColumn}.${probeRow}`
          let keySearchBelow = `${probeColumn}.${probeRow + 1}`

          if (!_.get(placementMap, keySearch)) {

            let newEntry = _.merge({}, {
              column: probeColumn,
              row: probeRow,
              logicalColumn: logicalColumnNumber,
              ties: _.cloneDeep(tieStack),
              marker: this.getMarker(gameResult),
              score: gameResult.score || null,
              result: gameResult.winner
            })
            tieStack = []
            _.set(placementMap, keySearch, newEntry)
            returnList.push(placementMap[probeColumn][probeRow])

            done = true
          } else if (probeRow + 1 >= rows) {
            // The spot below would go beyond the table bounds.
            probeColumn++
          } else if (!_.get(placementMap, keySearchBelow)) {
            // The spot below is empty.
            probeRow++
          } else if (_.get(placementMap,
            keySearchBelow).result === gameResult.winner) {
            // The result below is the same winner.
            probeRow++
          } else {
            probeColumn++
          }
        }

        maximumColumnReached = Math.max(maximumColumnReached,
          probeColumn)
      }

      lastItem = gameResult
    })

    // no winners added / only have ties.
    if (_.isEmpty(returnList) && tieStack.length > 0) {
      returnList.push({
        ties: _.cloneDeep(tieStack),
        column: 0,
        row: 0,
        logicalColumn: 0,
        marker: {},
        result: {}
      })
    } else if (!_.isEmpty(returnList)) {
      _.last(returnList).ties = _.cloneDeep(tieStack)
    }

    if (scroll) {
      returnList = this.scrollBlock(returnList,
        maximumColumnReached, columns)
    }

    // cut off data. as not use
    let finalData = []
    returnList.forEach(function (obj) {
      _.unset(obj, 'result')
      if (obj.score === null) {
        _.unset(obj, 'score')
      }
      if (_.isEmpty(obj.ties)) {
        _.unset(obj, 'ties')
      } else {
        obj.ties = obj.ties.length
      }
      finalData = _.concat(finalData, obj)
    })

    return finalData
  }

  scrollBlock(results, highestDrawingColumn, drawingColumns) {
    const highestDrawableIndex = drawingColumns - 1
    const offset = Math.max(0, highestDrawingColumn - highestDrawableIndex)

    let validItems = results.filter(
      (value) => (value.column - offset) >= 0)

    validItems.forEach((value) => value.column -= offset)

    return validItems
  }

  otherRoad(type, bigRoadStatistic, columns = this.columns, rows = this.row, scroll = this.scroll) {

    let returnList = []
    let start = 0
    let result
    //let index = 1 // for debug
    this.gameResults = this.convertObjectToArray3D(bigRoadStatistic)
    start = this.startIndex(type, this.gameResults)
    if (start) {
      let startColumn = start.column
      let startRow = start.row
      const distance = start.distance
      let probeColumn = startColumn
      let probeRow = startRow

      let keyStartSearch = parseFloat(`${startColumn}.${startRow}`)
      for (var actualColumn in this.gameResults) {
        var rowData = this.gameResults[actualColumn]
        if (actualColumn >= startColumn) {
          for (var actualRow in rowData) {
            let keyCurrentSearch = parseFloat(`${actualColumn}.${actualRow}`)
            // start calculate stats for big eye road, small road, cockroach Road
            if (keyCurrentSearch >= keyStartSearch) {
              const data = rowData[actualRow]
              result = this.calculateOtherRoad(distance, data)
              returnList = _.concat(returnList, { winner: result })
              //index = index + 1
            }
            //index = index + 1
          }
        }
      }

      return this.roadmap(returnList, columns, rows, scroll)
    }

    return {}
  }

  calculateOtherRoad(distance, data) {

    const currentRow = data.row
    let currentColumn = data.logicalColumn
    let compareColumn1
    let compareColumn2
    let sizeColumn1
    let sizeColumn2
    let result
    // find column for compare
    if (currentRow > 0) {
      // Rule 1
      compareColumn1 = currentColumn
      compareColumn2 = compareColumn1 - (1 * distance)
      // conversion
      sizeColumn1 = currentRow
      sizeColumn2 = this.gameResults[compareColumn2].length
      if (sizeColumn1 == sizeColumn2) {
        // Rule 1.2
        result = 'BLUE'
      } else {
        // Rule 1.1 and 1.3(Not subject to Rule 1.2)
        result = 'RED'
      }

    } else {
      // Rule 2
      compareColumn1 = currentColumn - 1
      compareColumn2 = compareColumn1 - (1 * distance)
      // conversion
      sizeColumn1 = this.gameResults[compareColumn1].length
      sizeColumn2 = this.gameResults[compareColumn2].length
      if (sizeColumn1 == sizeColumn2) {
        // Rule 2.1.1
        result = 'RED'
      } else {
        // Rule 2.1.2
        result = 'BLUE'
      }
    }
    return result
  }

  isNatural(gameResult, score) {
    if (_.indexOf(gameResult.addition, 'SMALL') !== -1 && score > 7) {
      return true
    }
    return false
  }

  getMarker(gameResult) {
    const winner = gameResult.winner
    let additional = null
    let result = winner

    if (_.indexOf(gameResult.addition, 'PERFECTPAIR') !== -1) {
      additional = 'PERFECTPAIR'
    } else if (_.indexOf(gameResult.addition, 'PPAIR') !== -1) {
      additional = 'PPAIR'
    } else if (_.indexOf(gameResult.addition, 'BPAIR') !== -1) {
      additional = 'BPAIR'
    }
    if (additional !== null) {
      result = winner + '-' + additional
    }
    return result
  }

  columnForGameNumber(gameNumber, columnSize) {
    return Math.floor(gameNumber / columnSize)
  }

  rowForGameNumber(gameNumber, columnSize) {
    return gameNumber % columnSize
  }

  convertObjectToArray3D(bigRoadStatistic) {
    let index = 0
    let placementMap = {}
    let lastColumn
    const gameResults = _.values(bigRoadStatistic)
    gameResults.forEach((gameResult) => {
      if (lastColumn !== gameResult.logicalColumn) {
        index = 0
      }
      let keySearch = `${gameResult.logicalColumn}.${index}`
      _.set(placementMap, keySearch, gameResult)
      lastColumn = gameResult.logicalColumn
      index = index + 1
    })
    return placementMap
  }

  startIndex(type, gameResults) {
    let pointFristColumn = 0
    let pointFristRow = 0
    let pointSecondColumn = 0
    let pointSecondRow = 0
    let distance = 0
    let start = 0

    switch (type) {
      case 'BigEyeRoad':
        pointFristColumn = 1
        pointFristRow = 1
        pointSecondColumn = 2
        pointSecondRow = 0
        distance = 1
        break
      case 'SmallRoad':
        pointFristColumn = 2
        pointFristRow = 1
        pointSecondColumn = 3
        pointSecondRow = 0
        distance = 2
        break
      case 'CockroachRoad':
        pointFristColumn = 3
        pointFristRow = 1
        pointSecondColumn = 4
        pointSecondRow = 0
        distance = 3
        break
    }
    let keySearch = `${pointFristColumn}.${pointFristRow}`

    if (_.get(gameResults, keySearch)) {
      return {
        column: pointFristColumn,
        row: pointFristRow,
        distance: distance
      }
    } else {
      keySearch = `${pointSecondColumn}.${pointSecondRow}`
      if (_.get(gameResults, keySearch)) {
        return {
          column: pointSecondColumn,
          row: pointSecondRow,
          distance: distance
        }
      }
    }

    return false
  }

}

module.exports = BaccaratRoadmap



// WEBPACK FOOTER //
// ./app/Support/PlayingCards/BaccaratRoadmap.js